import React, { memo } from 'react';
export function PricingSection() {
  const servicePlans = [{
    name: 'Cobertura de Eventos',
    price: '12,000 MXN',
    description: 'Documentamos tu evento como si fuera una expedición: desde la energía inicial hasta el último momento de celebración.',
    features: ['<span class="font-medium">Documento lo que pasa</span> y lo que se siente en cada momento', 'Fotografías que capturan la esencia y emoción del evento', 'Videos cortos para compartir en redes sociales', 'Historias en tiempo real desde mis canales', 'Publicación destacada en mi feed de Instagram', '30 imágenes editadas para uso de tu marca']
  }, {
    name: 'Embajador de Marca',
    price: '15,000 MXN',
    description: 'Tu marca se convierte en mi compañera de ruta, viajando conmigo y apareciendo de forma natural en aventuras y reflexiones.',
    features: ['<span class="font-medium">Tu marca viaja conmigo</span> a destinos que inspiran', '2 publicaciones mensuales en mi feed principal', '4 historias mensuales mostrando tu producto en acción', 'Integración natural en contenido de aventuras', 'Participación en eventos de marca relacionados', 'Reporte mensual de engagement y alcance']
  }, {
    name: 'Campañas 360°',
    price: '20,000 MXN',
    description: 'Diseñamos una campaña como quien planifica un gran viaje: con preparación, momentos clave y un destino que deja huella.',
    features: ['<span class="font-medium">Campañas que se sienten como un viaje</span> transformador', 'Estrategia completa de contenido para tus objetivos', 'Sesiones fotográficas exclusivas con tu producto', 'Video promocional que cuenta una historia real', 'Distribución en mis canales con 17K+ seguidores', 'Contenido adicional para tus propias plataformas']
  }];
  return <section className="w-full bg-gray-50 py-32" data-id="element-1048">
      <div className="container mx-auto px-6" data-id="element-1049">
        <div className="max-w-3xl mx-auto mb-40 pt-20" data-id="element-1050">
          <h2 className="text-3xl font-normal text-black mb-16 pt-10" data-id="element-1051">
            ¿Por qué colaborar conmigo?
          </h2>
          <p className="text-base text-gray-700 mb-10 leading-relaxed" data-id="element-1052">
            Porque no se trata solo de mostrar, sino de transformar. Trabajo con
            marcas que entienden que las aventuras no terminan al llegar a la
            meta: siguen en la manera en que las personas ven su vida después.
            Juntos podemos crear una{' '}
            <span className="font-medium" data-id="element-1053">conexión real</span> que no solo
            muestre paisajes, sino que{' '}
            <span className="font-medium" data-id="element-1054">
              inspire a salir, explorar y reconectar
            </span>{' '}
            con lo que realmente importa.
          </p>
          <div className="bg-white p-8 rounded-lg shadow-sm border-l-4 border-black" data-id="element-1055">
            <h3 className="text-lg font-medium text-black mb-5" data-id="element-1056">
              Valor para tu marca
            </h3>
            <p className="text-base text-gray-700 leading-relaxed" data-id="element-1057">
              Cada colaboración incluye la distribución a mi comunidad de más de{' '}
              <span className="font-medium" data-id="element-1058">17K personas</span> que no solo
              miran, sino que actúan. Son personas que han viajado después de
              ver mis contenidos, que han comprado equipos que uso, y que
              confían en las marcas que me acompañan porque saben que las elijo
              con el mismo cuidado con el que elijo cada sendero.
            </p>
          </div>
        </div>
        <div className="min-h-screen flex flex-col justify-center py-20" data-id="element-1059">
          <h2 className="text-3xl font-normal text-black mb-24 text-center pt-16" data-id="element-1060">
            Servicios Principales
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16" data-id="element-1061">
            {servicePlans.map((plan, index) => <div key={index} className="border-t-2 border-black pt-8 bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-1062">
                <h3 className="text-xl font-medium text-black mb-3" data-id="element-1063">
                  {plan.name}
                </h3>
                <div className="mb-6 flex flex-col" data-id="element-1064">
                  <span className="text-3xl font-normal text-black" data-id="element-1065">
                    {plan.price}
                  </span>
                  <span className="text-sm text-gray-600 mt-1" data-id="element-1066">
                    por proyecto
                  </span>
                </div>
                <p className="text-base text-gray-600 mb-8 leading-relaxed" data-id="element-1067">
                  {plan.description}
                </p>
                <ul className="space-y-4 mb-10" data-id="element-1068">
                  {plan.features.map((feature, featureIndex) => <li key={featureIndex} className="text-base text-gray-700 flex items-start" data-id="element-1069">
                      <span className="mr-2 text-black" data-id="element-1070">—</span>
                      <span dangerouslySetInnerHTML={{
                  __html: feature
                }} data-id="element-1071" />
                    </li>)}
                </ul>
                <a href="https://wa.me/16462819972" className="block bg-black text-white px-8 py-3 text-sm uppercase w-full rounded hover:bg-gray-800 transition-colors text-center" data-id="element-1072">
                  Solicitar
                </a>
              </div>)}
          </div>
          {/* Banner de cierre - Diseño en blanco */}
          <div className="relative overflow-hidden rounded-xl mt-16 mb-20 border border-gray-200" data-id="element-1073">
            <div className="absolute inset-0 bg-white" data-id="element-1074"></div>
            <div className="relative z-10 flex flex-col items-center text-center px-8 py-12" data-id="element-1075">
              <div className="w-16 h-1 bg-gray-300 mb-8" data-id="element-1076"></div>
              <h4 className="text-2xl font-normal text-black mb-4" data-id="element-1077">
                ¿Buscas algo a medida?
              </h4>
              <p className="text-base text-gray-600 mb-8 max-w-lg" data-id="element-1078">
                Cuéntame lo que necesitas y encontremos juntos la forma más
                efectiva de hacerlo realidad.
              </p>
              <a href="https://wa.me/16462819972" className="bg-black text-white px-10 py-4 text-sm uppercase rounded-full hover:bg-gray-800 transition-colors font-medium tracking-wider" data-id="element-1079">
                HABLEMOS
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}